(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2214],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 5095:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/clickThrough",
      function () {
        return __webpack_require__(44995);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fB": function() { return /* binding */ BuilderShowCaseSection; },
/* harmony export */   "uV": function() { return /* binding */ ShowCaseCard; }
/* harmony export */ });
/* unused harmony export showcaseData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const showcaseData = [
    {
        id: 1,
        navText: "Persona"
    },
    {
        id: 2,
        navText: "Knowledge"
    },
    {
        id: 3,
        navText: "ActionBooks"
    },
    {
        id: 4,
        navText: "Boundaries"
    }
];
function ShowCase(param) {
    let { scrollToCard , activeIndex , setActiveIndex , categories , isDarkMode  } = param;
    const handleClick = (idx)=>{
        setActiveIndex(idx);
        scrollToCard === null || scrollToCard === void 0 ? void 0 : scrollToCard(idx); // Call scroll function
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:flex-row md:flex hidden flex-col justify-center items-center w-full gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-1 md:w-auto w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col ",
                    children: categories === null || categories === void 0 ? void 0 : categories.map((item, idx)=>{
                        const isActive = activeIndex === idx;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "relative h-[46px] bg-transparent ".concat(isActive ? "" : "border-t", " ").concat(isDarkMode ? "text-gray-300" : "text-gray-600", "  flex justify-start items-center gap-2 hover:bg-black/ ").concat(isActive ? "border-gray-900 font-bold" : "border-gray-300"),
                            onClick: ()=>handleClick(idx),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "rounded-full border font-medium ".concat(isDarkMode ? "border-white" : "border-black", "  flex justify-center items-center w-7 h-7  ").concat(isActive ? "".concat(isDarkMode ? "bg-white text-black" : "bg-black text-white") : "".concat(isDarkMode ? "text-gray-300" : "text-black bg-transparents")),
                                    children: idx + 1
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative z-10 text-lg whitespace-nowrap",
                                    children: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    // background: linear-gradient(275deg, #c86aff -8.37%, #3164ff)
                                    // want to use linear -gradient as bg color
                                    className: "absolute top-0 left-0 h-[3px] bg-gradient-to-r from-[#c86aff] to-[#3164ff] transition-all ease-linear duration-300",
                                    style: {
                                        width: isActive ? "100%" : "0%"
                                    }
                                })
                            ]
                        }, item.id);
                    })
                })
            })
        })
    });
}
function ShowCaseCard(param) {
    let { title , desc , imgSrc , titleSize ="4xl" , descSize ="xl" , gap =0 , mb =0 , idx =0 , cat  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-4 md:gap-8 pb-12 md:pb-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:flex-row gap-3 md:gap-8 mb-8 ".concat(cat ? "border-t border-gray-300 pt-4" : "", " md:border-0 md:pt-0"),
                children: [
                    cat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-2 md:hidden ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                // isActive ? "bg-black text-white" : "text-black bg-transparents"
                                className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white inline",
                                children: idx + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "relative z-10 text-lg inline font-medium",
                                children: cat
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "flex-1 text-2xl md:text-".concat(titleSize, " font-semibold"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "flex-1 text-".concat(descSize, " "),
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: imgSrc,
                alt: "ai-agent-builder",
                width: 1280,
                height: 490,
                className: "w-full object-cover h-full rounded-xl md:rounded-[30px]"
            })
        ]
    });
}
const BuilderShowCaseSection = (param)=>{
    let { heading ="" , categories =[] , showcaseData =[] , isDarkMode =false  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const cardRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const scrollingRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // const scrollToCard = (index) => {
    //   cardRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
    //   setActiveIndex(index);
    // };
    // Scroll to card when activeIndex changes
    const scrollToCard = (index)=>{
        var _cardRefs_current_index;
        scrollingRef.current = true;
        (_cardRefs_current_index = cardRefs.current[index]) === null || _cardRefs_current_index === void 0 ? void 0 : _cardRefs_current_index.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        // Reset scrolling flag after animation completes
        setTimeout(()=>{
            scrollingRef.current = false;
        }, 1000);
    };
    // Set up Intersection Observer to detect which card is in view
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const observerOptions = {
            root: null,
            rootMargin: "0px 0px -50% 0px",
            threshold: 0.1
        };
        const observerCallback = (entries)=>{
            // Ignore during programmatic scrolling
            if (scrollingRef.current) return;
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const index = cardRefs.current.findIndex((ref)=>ref === entry.target);
                    if (index !== -1) {
                        setActiveIndex(index);
                    }
                }
            });
        };
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        // Observe all cards
        cardRefs.current.forEach((card)=>{
            if (card) observer.observe(card);
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto py-10 ".concat(isDarkMode ? "text-white" : "text-gray-900"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-4xl md:text-5xl font-semibold mb-16 md:mb-24 md:pl-72",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-2 w-[24%] pr-12 hidden md:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full sticky top-[113px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCase, {
                                    scrollToCard: scrollToCard,
                                    activeIndex: activeIndex,
                                    setActiveIndex: setActiveIndex,
                                    categories: categories,
                                    isDarkMode: isDarkMode
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 ",
                            children: showcaseData.map((data, idx)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: (el)=>cardRefs.current[idx] = el,
                                    className: "scroll-mt-[130px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCaseCard, {
                                        title: data.heading,
                                        desc: data.subHeading,
                                        imgSrc: data.imgSrc,
                                        idx: idx,
                                        cat: categories === null || categories === void 0 ? void 0 : categories[idx]
                                    })
                                }, idx);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 39669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


const ProactiveCard = (param)=>{
    let { title , desc , videoSrc ="" , imgSrc ="" , isImageRight =true , bgColor ="bg-white"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-8 md:gap-12  ".concat(bgColor),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 text-start flex flex-col justify-center items-center ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " ").concat(isImageRight ? "md:order-1" : "md:order-2"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-4xl md:text-5xl font-semibold mb-4 md:mb-8",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-lg font-medium ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-600", " md:text-2xl md:mb-9"),
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " ".concat(isImageRight ? "md:order-2" : "md:order-1", " flex-1"),
                children: [
                    videoSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        src: videoSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl w-full",
                        autoPlay: true,
                        loop: true,
                        muted: true
                    }),
                    imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: imgSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl  w-full"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProactiveCard);


/***/ }),

/***/ 44995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_BuilderShowCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71575);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39669);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);








const CLMHeroData = {
    // title: "Reporting",
    heading: "Secure, trackable clickwraps for high-scale workflows",
    description: "Let users to accept terms, policies, and agreements instantly, while you capture consent with legal proof and audit trails.",
    image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-hero.png"),
    btnText: "Request a Demo",
    btnUrl: "/clm/request-demo"
};
const showcaseData = [
    {
        heading: "Embed clickwrap to your site in 3 easy steps",
        subHeading: "Add clickwrap agreements to your site with a simple code snippet, no complex setup, dev hours, or custom tools required.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-embed-2.png")
    },
    {
        heading: "Audit-ready records for every agreement",
        subHeading: "Capture every agreement with time, identity, and IP—fully auditable and legally enforceable.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-document-send-1.png")
    },
    {
        heading: "Track consent across every version",
        subHeading: "Always show users the right contract, auto-save updates, and know exactly who accepted which version.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-terms-1.png")
    },
    {
        heading: "Centralize your clickwrap lifecycle",
        subHeading: "One place to store, manage, and track every clickwrap agreement, with full visibility for legal teams.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-delta-1.png")
    }
];
const clickThroughFaqData = [
    {
        question: "What is BoloSign Clickwrap and how does it work?",
        answer: "BoloSign Clickwrap lets users accept agreements (like Terms of Service or Privacy Policies) with a single click. You just embed a small code snippet on your site, and we handle consent tracking, versioning, and compliance for you."
    },
    {
        question: "Is BoloSign Clickthrough legally enforceable?",
        answer: "Yes. Every click is backed by a verifiable audit trail and certificate of completion. That means you have solid proof in case of any dispute, enforceable under laws like the ESIGN Act and UETA."
    },
    {
        question: "How do I implement clickwrap on my site?",
        answer: "It takes just one embed code. Copy, paste, and you’re live. No dev team dependency or any complex integrations.. And yes, it works with modern web frameworks like React, Webflow, and even no-code platforms."
    },
    {
        question: "How does BoloSign handle updates to terms?",
        answer: "Every version of your clickwrap is tracked automatically. When you update the terms, users are shown the new version, and their consent is logged. You can easily see who accepted which version and when."
    },
    {
        question: "Does BoloSign Clickthrough integrate with our existing systems?",
        answer: "Definitely. You can sync consent data with tools like HubSpot, Zapier, Segment, or use our API to push it to any system. BoloSign Clickwrap gives you full visibility into who accepted what, with filters by date, status, agreement type, and more."
    },
    {
        question: "What kind of reporting or insights can I get?",
        answer: "You get real-time reports showing who agreed, when, from which device and location. Filter by date, domain, or even specific versions, all downloadable and audit-ready."
    },
    {
        question: "Can I brand the clickwrap to match our company’s style?",
        answer: "Absolutely. You can host the clickwrap on your own domain, using your logo, fonts, and styling. It blends seamlessly with your site’s brand while maintaining legal integrity"
    }
];
const ClickThrough = (param)=>{
    let { isDarkMode , setIsDarkMode  } = param;
    const sectionRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const handleScroll = ()=>{
            const rect = section.getBoundingClientRect();
            const topTrigger = 120; // or some margin like 100
            const bottomTrigger = window.innerHeight;
            const isInView = rect.top <= topTrigger && rect.bottom >= bottomTrigger / 2;
            setIsDarkMode(isInView);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Initial check
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Clickwrap Software for Legal Teams | BoloSign CLM Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloSign Clickwrap lets legal teams create, manage, and track click-to-accept agreements easily. Capture user consent with audit trails and version control."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Clickwrap software, click-to-accept agreements, user consent management, legal tech, BoloSign clickwrap, contract management, audit trails, version control"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/clickThrough/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto py-16 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        // imgSrc={`${BASE_ASSETS_URL}/v2/clm/clm/clickThrough-centralized.gif")}
                        videoSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/videos/clickThrough-centralized.mp4"),
                        title: "Centralized terms management",
                        desc: "Quickly update, publish, and track your terms—ensuring users always access the latest version without IT delays.",
                        isImageRight: true,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "transition-colors duration-300  ".concat(isDarkMode ? "bg-dark text-white" : "bg-white text-black"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    ref: sectionRef,
                    className: "pt-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_BuilderShowCase__WEBPACK_IMPORTED_MODULE_2__/* .BuilderShowCaseSection */ .fB, {
                        heading: "Full control over every clickwrap",
                        // Implementation, Audit Trial, Version Control, Legal
                        categories: [
                            "Implementation",
                            "Audit Trial",
                            "Version Control",
                            "Legal"
                        ],
                        showcaseData: showcaseData,
                        isDarkMode: isDarkMode
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center bg-cream py-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        className: "text-4xl md:text-6xl font-semibold mb-8 leading-relaxed",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block",
                                children: "Why legal teams love"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block md:mt-3",
                                children: "BoloSign clickwrap"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl lg:w-[70%] xl:w-[50%] mx-auto px-6 md:px-0",
                        children: "Built for legal teams to launch, track, and update clickwraps without relying on engineering."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto pt-16 md:pt-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-opensans.png"),
                        title: "Edit contracts like you write emails",
                        desc: "Make updates easily with a simple, no-training-needed editor, just like using Google Docs or Word.",
                        isImageRight: true,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto pt-16 md:pt-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-disk.png"),
                        title: "Get contract insights instantly",
                        desc: "Auto-generate reports with key data like signers, versions, and timestamps, no manual tracking needed.",
                        isImageRight: false,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto pt-16 md:pt-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-legal.png"),
                        title: "Host clickwraps on your own domain",
                        desc: "Reinforce brand trust and legal credibility by showing agreements directly from your website.",
                        isImageRight: true,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto py-16 md:py-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ProactiveCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/clickThrough-logo.png"),
                        title: "Match every contract to your brand",
                        desc: "Add your logo, use custom fonts, and format contracts to reflect your company’s visual identity.",
                        isImageRight: false,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    faqData: clickThroughFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ClickThrough);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(5095); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);